import { Alert } from 'foundations-components/transitional/components/Alert';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getAlertType(bannerType) {
  switch (bannerType) {
    case 'FIRE_ALARM':
      return 'danger';
    case 'ANNOUNCEMENT':
      return 'tip';
    case 'NAMED_DISCOUNT':
    case 'UNNAMED_DISCOUNT':
    default:
      return 'info';
  }
}
function hasCTA(designType) {
  return typeof designType === 'string' && designType.includes('WITH_CTA');
}
function isDismissable(designType) {
  return typeof designType === 'string' && designType.includes('DISMISSIBLE');
}
export const DynamicBanner = ({
  headline,
  description,
  designType,
  bannerType,
  onDismiss,
  purchaseMotionCTA
}) => {
  const isMobile = useIsMobile();
  const closeable = isDismissable(designType);
  const showCTA = hasCTA(designType) && purchaseMotionCTA;
  const alertType = getAlertType(bannerType);
  const ctaButton = showCTA ? /*#__PURE__*/_jsx(Flex, {
    flexDirection: isMobile ? 'column' : 'row',
    inlineSize: isMobile ? '100%' : undefined,
    children: purchaseMotionCTA
  }) : null;
  return /*#__PURE__*/_jsx(Alert, {
    type: alertType,
    titleText: headline,
    inlineSize: "100%",
    closeable: closeable,
    onClose: closeable ? onDismiss : undefined,
    children: ctaButton ? /*#__PURE__*/_jsxs(Flex, {
      flexDirection: isMobile ? 'column' : 'row',
      justifyContent: "space-between",
      alignItems: "start",
      gap: isMobile ? '300' : '200',
      paddingBlockStart: isMobile ? '200' : undefined,
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        children: description
      }), ctaButton]
    }) : description
  });
};